"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _floor2 = _interopRequireDefault(require("lodash/floor"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DropDownDynamicGenerator = {
  labels: function labels() {
    var _Entry;
    if ((_Entry = Entry) !== null && _Entry !== void 0 && (_Entry = _Entry.aiLearning) !== null && _Entry !== void 0 && (_Entry = _Entry.labels) !== null && _Entry !== void 0 && _Entry.length) {
      return Entry.aiLearning.labels.map(function (name, index) {
        return [name, index];
      });
    } else {
      return [[Lang.Blocks.no_target, 'null']];
    }
  },
  tableAttrFields: function tableAttrFields() {
    var _Entry$aiLearning, _Entry$aiLearning$get;
    var table = (_Entry$aiLearning = Entry.aiLearning) === null || _Entry$aiLearning === void 0 || (_Entry$aiLearning$get = _Entry$aiLearning.getTableData) === null || _Entry$aiLearning$get === void 0 ? void 0 : _Entry$aiLearning$get.call(_Entry$aiLearning);
    if (table) {
      var _ref = table || {},
        _ref$select = _ref.select,
        select = _ref$select === void 0 ? [] : _ref$select,
        fields = _ref.fields;
      var attr = (select === null || select === void 0 ? void 0 : select[0]) || [];
      return attr.map(function (fieldIndex, idx) {
        return [fields[fieldIndex], idx];
      });
    } else {
      return [[Lang.Blocks.no_target, 'null']];
    }
  },
  valueMap: function valueMap() {
    var _Entry$aiLearning$get2, _Entry$aiLearning2;
    var valueMap = Object.values(((_Entry$aiLearning$get2 = Entry.aiLearning.getTrainResult()) === null || _Entry$aiLearning$get2 === void 0 ? void 0 : _Entry$aiLearning$get2.valueMap) || ((_Entry$aiLearning2 = Entry.aiLearning) === null || _Entry$aiLearning2 === void 0 || (_Entry$aiLearning2 = _Entry$aiLearning2.result) === null || _Entry$aiLearning2 === void 0 ? void 0 : _Entry$aiLearning2.valueMap) || {}) || [];
    if (valueMap !== null && valueMap !== void 0 && valueMap.length) {
      return valueMap.map(function (name) {
        return [name, name];
      });
    } else {
      return [[Lang.Blocks.no_target, 'null']];
    }
  }
};
var createParamBlock = function createParamBlock(_ref2) {
  var name = _ref2.name,
    length = _ref2.length,
    createFunc = _ref2.createFunc,
    _ref2$skeleton = _ref2.skeleton,
    skeleton = _ref2$skeleton === void 0 ? 'basic_string_field' : _ref2$skeleton,
    _ref2$params = _ref2.params,
    params = _ref2$params === void 0 ? [] : _ref2$params,
    type = _ref2.type;
  var result = {};
  new Array(length).fill(0).forEach(function (_, idx) {
    var index = idx + 1;
    var blockName = "".concat(name, "_").concat(index);
    var EmptyArray = new Array(index * 2).fill(0);
    var lastAttr = {
      key: 1,
      value: 1
    };
    var paramsKeyMap = EmptyArray.reduce(function (acc, cur, idx, array) {
      if (idx % 2 !== 0) {
        return acc;
      }
      var index = idx / 2 + 1;
      acc["ATTR".concat(index)] = idx + 1;
      lastAttr.key = index;
      lastAttr.value = idx + 1;
      return acc;
    }, {});
    if (params.length) {
      params.forEach(function (p, i) {
        paramsKeyMap["ATTR".concat(lastAttr.key + i + 1)] = lastAttr.value + 1;
      });
    }
    result[blockName] = {
      color: EntryStatic.colorSet.block["default"].AI_LEARNING,
      outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
      skeleton: skeleton,
      statements: [],
      params: [].concat((0, _toConsumableArray2["default"])(EmptyArray.map(function (_, i) {
        if (i % 2 !== 0) {
          return {
            type: 'Block',
            accept: 'string',
            defaultType: 'number'
          };
        }
        return {
          type: 'TextDynamic',
          setValue: function setValue() {
            var _Entry$aiLearning3, _Entry$aiLearning3$ge;
            var table = (_Entry$aiLearning3 = Entry.aiLearning) === null || _Entry$aiLearning3 === void 0 || (_Entry$aiLearning3$ge = _Entry$aiLearning3.getTableData) === null || _Entry$aiLearning3$ge === void 0 ? void 0 : _Entry$aiLearning3$ge.call(_Entry$aiLearning3);
            if (table) {
              var _Entry$aiLearning4, _Entry$aiLearning4$ge, _select$;
              var _Entry$aiLearning$get3 = (_Entry$aiLearning4 = Entry.aiLearning) === null || _Entry$aiLearning4 === void 0 || (_Entry$aiLearning4$ge = _Entry$aiLearning4.getTableData) === null || _Entry$aiLearning4$ge === void 0 ? void 0 : _Entry$aiLearning4$ge.call(_Entry$aiLearning4),
                _Entry$aiLearning$get4 = _Entry$aiLearning$get3.select,
                select = _Entry$aiLearning$get4 === void 0 ? [] : _Entry$aiLearning$get4,
                _Entry$aiLearning$get5 = _Entry$aiLearning$get3.fields,
                fields = _Entry$aiLearning$get5 === void 0 ? [] : _Entry$aiLearning$get5;
              return fields[select === null || select === void 0 || (_select$ = select[0]) === null || _select$ === void 0 ? void 0 : _select$[i / 2]] || Lang.AiLearning.model_attr_str;
            }
            return Lang.AiLearning.model_attr_str;
          }
        };
      })), (0, _toConsumableArray2["default"])(params)),
      events: {},
      def: {
        type: blockName
      },
      pyHelpDef: {
        params: [],
        type: blockName
      },
      paramsKeyMap: paramsKeyMap,
      "class": 'ai_learning',
      isNotFor: Array.isArray(type) ? type.map(function (element) {
        return "".concat(element, "_attr_").concat(index);
      }) : ["".concat(type, "_attr_").concat(index)],
      func: createFunc(paramsKeyMap),
      syntax: {
        js: [],
        py: []
      }
    };
  });
  return result;
};
module.exports = {
  DropDownDynamicGenerator: DropDownDynamicGenerator,
  createParamBlock: createParamBlock,
  getBlocks: function getBlocks() {
    return _objectSpread(_objectSpread(_objectSpread({}, predictBlocks), booleanPredictBlocks), {}, {
      learning_title_image: {
        skeleton: 'basic_text',
        color: EntryStatic.colorSet.common.TRANSPARENT,
        params: [{
          type: 'Text',
          text: Lang.template.learning_title_image_str,
          color: EntryStatic.colorSet.common.TEXT,
          align: 'center'
        }],
        def: {
          type: 'learning_title_image'
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_image'],
        events: {},
        wikiClass: 'ai_image'
      },
      learning_title_speech: {
        skeleton: 'basic_text',
        color: EntryStatic.colorSet.common.TRANSPARENT,
        params: [{
          type: 'Text',
          text: Lang.template.learning_title_speech_str,
          color: EntryStatic.colorSet.common.TEXT,
          align: 'center'
        }],
        def: {
          type: 'learning_title_speech'
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_speech'],
        events: {},
        wikiClass: 'ai_speech'
      },
      learning_title_text: {
        skeleton: 'basic_text',
        color: EntryStatic.colorSet.common.TRANSPARENT,
        params: [{
          type: 'Text',
          text: Lang.template.learning_title_text_str,
          color: EntryStatic.colorSet.common.TEXT,
          align: 'center'
        }],
        def: {
          type: 'learning_title_text'
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_text'],
        events: {},
        wikiClass: 'ai_text'
      },
      insert_data_for_test: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null],
          type: 'insert_data_for_test'
        },
        pyHelpDef: {
          params: [],
          type: 'insert_data_for_test'
        },
        paramsKeyMap: {},
        "class": 'ai_learning',
        isNotFor: ['ai_learning_classification'],
        func: function func(sprite, script) {
          if (!script.isStart) {
            script.isStart = true;
            Entry.aiLearning.openInputPopup();
            return script;
          }
          if (!Entry.aiLearning.isLoading) {
            delete script.isStart;
            return script.callReturn();
          }
          return script;
        },
        syntax: {
          js: [],
          py: []
        }
      },
      video_capture_for_image_test: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Dropdown',
          options: [[Lang.Blocks.video_start, 'start'], [Lang.Blocks.video_end, 'stop']],
          value: 'on',
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }, {
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          params: ['start', null],
          type: 'video_capture_for_image_test'
        },
        pyHelpDef: {
          params: [],
          type: 'video_capture_for_image_test'
        },
        paramsKeyMap: {
          MODE: 0
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_image'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
            var mode;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  mode = script.getField('MODE');
                  if (mode === 'start') {
                    Entry.aiLearning.startPredict();
                  } else {
                    Entry.aiLearning.stopPredict();
                  }
                  return _context.abrupt("return", script.callReturn());
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }))();
        },
        syntax: {
          js: [],
          py: []
        },
        wikiClass: 'ai_image'
      },
      insert_text_block_for_test: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Block',
          accept: 'string'
        }, {
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [{
            type: 'text',
            params: [Lang.Blocks.entry]
          }, null],
          type: 'insert_text_block_for_test'
        },
        pyHelpDef: {
          params: [],
          type: 'insert_text_block_for_test'
        },
        paramsKeyMap: {
          TEXT: 0
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_text'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
            var text;
            return _regenerator["default"].wrap(function (_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  text = script.getStringValue('TEXT', script);
                  _context2.next = 1;
                  return Entry.aiLearning.predict(text);
                case 1:
                  return _context2.abrupt("return", script.callReturn());
                case 2:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }))();
        },
        syntax: {
          js: [],
          py: []
        },
        wikiClass: 'ai_text'
      },
      test_result: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [],
        events: {},
        def: {
          params: [null],
          type: 'test_result'
        },
        pyHelpDef: {
          params: [],
          type: 'test_result'
        },
        paramsKeyMap: {},
        "class": 'ai_learning',
        isNotFor: ['ai_learning_classification'],
        func: function func(sprite, script) {
          return Entry.aiLearning.getPredictResult().className;
        },
        syntax: {
          js: [],
          py: []
        }
      },
      accuracy_of_result: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: DropDownDynamicGenerator.labels,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }],
        events: {},
        def: {
          params: [0],
          type: 'accuracy_of_result'
        },
        pyHelpDef: {
          params: [],
          type: 'accuracy_of_result'
        },
        paramsKeyMap: {
          GROUP: 0
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_classification'],
        func: function func(sprite, script) {
          var group = script.getNumberValue('GROUP', script);
          return Entry.aiLearning.getPredictResult(group).probability;
        },
        syntax: {
          js: [],
          py: []
        }
      },
      is_group: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_boolean_field',
        statements: [],
        params: [{
          type: 'DropdownDynamic',
          value: null,
          menuName: DropDownDynamicGenerator.labels,
          needDeepCopy: true,
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE,
          defaultValue: function defaultValue(value, options) {
            if (options[0] && options[0][1]) {
              return options[0][1];
            }
            return value || 0;
          }
        }],
        events: {},
        def: {
          params: [0],
          type: 'is_group'
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_classification'],
        paramsKeyMap: {
          GROUP: 0
        },
        func: function func(sprite, script) {
          var group = script.getNumberValue('GROUP', script);
          var labels = Entry.aiLearning.labels;
          var result = Entry.aiLearning.getPredictResult().className;
          return result === labels[group];
        },
        syntax: {
          js: [],
          py: []
        }
      },
      retrain_model: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          params: [null],
          type: 'retrain_model'
        },
        pyHelpDef: {
          params: [],
          type: 'retrain_model'
        },
        paramsKeyMap: {
          TEXT: 0
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_train'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
            return _regenerator["default"].wrap(function (_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  Entry.aiLearning.train();
                  return _context3.abrupt("return", script.callReturn());
                case 1:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      model_is_trained: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_boolean_field',
        statements: [],
        params: [],
        events: {},
        def: {
          type: 'model_is_trained'
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_train'],
        func: function func(sprite, script) {
          return Entry.aiLearning.isTrained();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      set_train_visible: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Dropdown',
          options: [[Lang.AiLearning.show, 'show'], [Lang.AiLearning.hide, 'hide']],
          value: 'show',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }, {
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          params: ['show', null],
          type: 'set_train_visible'
        },
        pyHelpDef: {
          params: [],
          type: 'set_train_visible'
        },
        paramsKeyMap: {
          VISIBLE: 0
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_train'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
            var visible;
            return _regenerator["default"].wrap(function (_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  visible = script.getField('VISIBLE');
                  Entry.aiLearning.setVisible(visible === 'show');
                  return _context4.abrupt("return", script.callReturn());
                case 1:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      set_train_chart: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Dropdown',
          options: [[Lang.AiLearning.open, 'open'], [Lang.AiLearning.close, 'close']],
          value: 'open',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }, {
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          params: ['open', null],
          type: 'set_train_chart'
        },
        pyHelpDef: {
          params: [],
          type: 'set_train_chart'
        },
        paramsKeyMap: {
          VISIBLE: 0
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_train_chart'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
            var visible;
            return _regenerator["default"].wrap(function (_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  visible = script.getField('VISIBLE');
                  Entry.aiLearning.setChartVisible(visible === 'open');
                  return _context5.abrupt("return", script.callReturn());
                case 1:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      get_result_info: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic_string_field',
        statements: [],
        params: [{
          type: 'Dropdown',
          options: [[Lang.AiLearning.accuracy, 'accuracy'], [Lang.AiLearning.f1, 'f1'], [Lang.AiLearning.precision, 'precision'], [Lang.AiLearning.recall, 'recall']],
          value: 'accuracy',
          fontSize: 11,
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }],
        events: {},
        def: {
          type: 'get_result_info'
        },
        pyHelpDef: {
          params: [],
          type: 'get_result_info'
        },
        paramsKeyMap: {
          TYPE: 0
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_svm', 'ai_learning_logistic_regression', 'ai_learning_decisiontree'],
        func: function func(sprite, script) {
          return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6() {
            var _Entry$aiLearning5;
            var type, result;
            return _regenerator["default"].wrap(function (_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  type = script.getField('TYPE', script);
                  result = (_Entry$aiLearning5 = Entry.aiLearning) === null || _Entry$aiLearning5 === void 0 ? void 0 : _Entry$aiLearning5.getTrainResult();
                  return _context6.abrupt("return", result === null || result === void 0 ? void 0 : result[type]);
                case 1:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }))();
        },
        syntax: {
          js: [],
          py: []
        }
      }
    });
  }
};
var predictBlocks = createParamBlock({
  type: ['svm', 'logistic_regression', 'decisiontree'],
  name: 'get_predict',
  length: 6,
  createFunc: function createFunc(paramsKeyMap) {
    return /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(sprite, script) {
        var params, result;
        return _regenerator["default"].wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              params = Object.keys(paramsKeyMap).map(function (key) {
                return script.getNumberValue(key, script);
              });
              _context7.next = 1;
              return Entry.aiLearning.predict(params);
            case 1:
              result = Entry.aiLearning.getPredictResult();
              return _context7.abrupt("return", result.sort(function (a, b) {
                return b.probability - a.probability;
              })[0].className);
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }();
  }
});
var booleanPredictBlocks = createParamBlock({
  type: ['svm', 'logistic_regression', 'decisiontree'],
  name: 'is_result',
  skeleton: 'basic_boolean_field',
  length: 6,
  createFunc: function createFunc(paramsKeyMap) {
    return /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(sprite, script) {
        var keys, predictKey, params, predict, predictResult, result;
        return _regenerator["default"].wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              keys = Object.keys(paramsKeyMap);
              predictKey = keys.pop();
              params = keys.map(function (key) {
                return script.getNumberValue(key, script);
              });
              predict = script.getStringField(predictKey, script);
              _context8.next = 1;
              return Entry.aiLearning.predict(params);
            case 1:
              predictResult = Entry.aiLearning.getPredictResult();
              result = predictResult.sort(function (a, b) {
                return b.probability - a.probability;
              })[0];
              return _context8.abrupt("return", result && !!result.probability && result.className === predict);
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function (_x3, _x4) {
        return _ref4.apply(this, arguments);
      };
    }();
  },
  params: [{
    type: 'DropdownDynamic',
    value: null,
    menuName: DropDownDynamicGenerator.valueMap,
    needDeepCopy: true,
    fontSize: 11,
    bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
    arrowColor: EntryStatic.colorSet.common.WHITE,
    defaultValue: function defaultValue(value, options) {
      if (options[0] && options[0][1]) {
        return options[0][1];
      }
      return value || 0;
    }
  }]
});